import axios from "../request";

//咨询/课程-分类列表查询
export const categoryList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/category/categoryList",
    method: "post",
    data
  });
};
//咨询-获取新闻列表
export const selectNews = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/selectNews",
    method: "post",
    data
  });
};
//课程-查询列表
export const queryListPage = (data) => {
  return axios({
    url: "tvrjet-pinganfu-information-app/lessionUnion/queryListPage",
    method: "post",
    data
  });
};
//获取课程组列表
export const getCategoryList = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getCategoryList",
    method: "get",
    data
  });
};
//获取课程组列表
export const getGroupList = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/loadPublicGroupList",
    method: "post",
    data
  });
};
//获取学习时间
export const getStudyTime = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getStudyTime",
    method: "get",
    data
  });
};
//获取资讯详情
export const getNewsDetail = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/getNewsDetail",
    method: "post",
    data
  });
};
//资讯-点赞
export const newsGiveTheSupport = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/giveTheSupport",
    method: "post",
    data
  });
};
//资讯-取消点赞
export const newsCancelGiveTheSupport = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/cancelGiveTheSupport",
    method: "post",
    data
  });
};
//资讯-收藏
export const newsCollection = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/newsCollection",
    method: "post",
    data
  });
};
//资讯-取消收藏
export const cancelNewsCollection = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/cancelNewsCollection",
    method: "post",
    data
  });
};

//获取收藏课程列表
export const getGroupCollectionList = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupCollectionList",
    method: "get",
    data
  });
};
//当前用户的资讯收藏列表
export const currentUserNewsCollectionList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/news/currentUserCollectionList",
    method: "post",
    data
  });
};
//当前用户的小视频收藏列表
export const currentUserLessionCollectionList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/currentUserCollectionList",
    method: "post",
    data
  });
};

//获取学习历史
export const getStudyHistory = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getStudyHistory",
    method: "get",
    data
  });
};

//获取课程详情
export const getGroupDetail = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupDetail",
    method: "post",
    data
  });
};

//获取公开课程/授权课程  课时视频（课程列表）/相关课件列表
export const getClassesOrResource = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getClassesOrResource",
    method: "post",
    data
  });
};

//保存学习进度
export const saveWatchStep = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveUserClassProcess",
    method: "post",
    data
  });
};
//添加课程收藏
export const addGroupCollection = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/addGroupCollection",
    method: "post",
    data
  });
};
//删除课程收藏
export const delGroupCollection = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/delGroupCollection",
    method: "post",
    data
  });
};
//获取课程评价
export const getGroupRate = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupRate",
    method: "post",
    data
  });
};
//保存课程评价
export const saveGroupRate = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveGroupRate",
    method: "post",
    data
  });
};
//获取getPPT
export const getPPT = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getPPT",
    method: "post",
    data
  });
};

//小视频详情
export const queryLittleVideoDetail = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/queryListPage",
    method: "post",
    data
  });
};
//小视频-取消点赞
export const lessionCancelGiveTheSupport = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/cancelGiveTheSupport",
    method: "post",
    data
  });
};
//小视频-点赞
export const lessionGiveTheSupport = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/giveTheSupport",
    method: "post",
    data
  });
};
//小视频-收藏
export const lessionCollection = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/lessionCollection",
    method: "post",
    data
  });
};
//小视频-取消收藏
export const cancelLessionCollection = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/lession/cancelLessionCollection",
    method: "post",
    data
  });
};
//学习进度查询
export const getTrainReportDatasByTRQRCode = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getTrainReportDatasByTRQRCode",
    method: "post",
    data
  });
};
//通过企业id获取企业报表总数量
export const getTrainReportDatasByCorpid = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getTrainReportDatasByCorpid",
    method: "get",
    data
  });
};
//获取单报表信息
export const getReportListInfo = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getTrainReportList",
    method: "post",
    data
  });
};
// 增加报表
export const addReportForm = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/reportForm/addReportForm",
    method: "post",
    data
  });
};

// 获取报表
export const queryReportForm = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/reportForm/queryCurrentFormIdList",
    method: "post",
    data
  });
};
// 获取集合报表
export const queryReportFormList = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/reportForm/currentUserList",
    method: "post",
    data
  });
};
//同步企业报表
export const syncDataCom = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/reportForm/syncDataCom",
    method: "post",
    data
  });
};
//获取综合测试/练习题
export const getTestPaper = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getTestPaper",
    method: "post",
    data
  });
};
//获取当前用户课程笔记
export const getGroupNote = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupNote",
    method: "post",
    data
  });
};
//添加/保存/删除课程笔记
export const saveGroupNote = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveGroupNote",
    method: "post",
    data
  });
};
//保存开始分数
export const saveTestScore = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveTestScore",
    method: "post",
    data
  });
};
//获取题目设置
export const getQuestionSet = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getQuestionSet",
    method: "post",
    data
  });
};
//获取用户答题详情
export const getUserAnswerDetail = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getUserAnswerDetail",
    method: "get",
    data
  });
};
//获取证书列表
export const getCertpics = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getCertpics",
    method: "post",
    data
  });
};
// 增加播放量
export const watchCount = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveWatchnum",
    method: "get",
    data
  });
};
//获取是否有受邀课程
export const identifyInviteGroup = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/identifyInviteGroup",
    method: "get",
    data
  });
};
//获取当前状态
export const getGroupAuthStatus = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupAuthStatus",
    method: "get",
    data
  });
};
//检查是否下架
export const getGroupCloseStatus = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getGroupCloseStatus",
    method: "get",
    data
  });
};
//根据 code 查询受邀信息
export const getQRInfo = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getQRInfo",
    method: "get",
    data
  });
};
//完善受邀信息
export const saveTRInfo = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/saveTRInfo",
    method: "post",
    data
  });
};
//删除报表
export const deleteReportForm = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-information-app/reportForm/deleteReportForm",
    method: "post",
    data
  });
};
//获取集合报表综合信息
export const getMixRepInfo = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getMixRepInfo",
    method: "get",
    data
  });
};
//获取集合报表列表
export const getMixReportList = (data) => {
  return axios({
    service: "COURSE_URL",
    url: "/WebApp/App/getMixReportList",
    method: "get",
    data
  });
};

//获取app详情
export const detailAppInfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/detailAppInfo",
    method: "post",
    data
  });
};
//获取app详情扩展
export const expDetailAppInfo = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/expDefaultApplication/detailAppInfo",
    method: "get",
    data
  });
};

//我的应用(工作台)
export const myApp = (data) => {
  return axios({
    url: "/tvrjet-pinganfu-cust-app/defaultApplication/myApp",
    method: "post",
    data
  });
};